import type { ReactNode } from "react";

import useHasPermissions from "src/hooks/useHasPermissions";
import type { PermissionCheck } from "src/types/auth";

interface PermissionWrapperProps {
	children: ReactNode;
	permission: PermissionCheck;
}

/** Renders `children` only when the signed-in user satisfies `permission`. */
const PermissionWrapper = ({ children, permission }: PermissionWrapperProps) => {
	const hasPermission = useHasPermissions(permission);

	if (!hasPermission) return null;

	// Fragment rather than a bare `children`: several call sites pass sibling elements.
	return <>{children}</>;
};

export default PermissionWrapper;
